import React, { useEffect, createElement } from 'react';
import { HeroSection } from './components/HeroSection';
import { HonestQuestion } from './components/HonestQuestion';
import { ProblemSection } from './components/ProblemSection';
import { TomosSection } from './components/TomosSection';
import { BonusSection } from './components/BonusSection';
import { ForWhoSection } from './ForWhoSection';
import { PricingSection } from './components/PricingSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { FAQSection } from './components/FAQSection';
import { Footer } from './components/Footer';
import { SocialProofPopup } from './components/SocialProofPopup';
import { UrgencyBar } from './components/UrgencyBar';
export function App() {
  useEffect(() => {
    // Preconnect to CDN for faster image loading
    const cdnPreconnect = document.createElement('link');
    cdnPreconnect.rel = 'preconnect';
    cdnPreconnect.href = 'https://cdn.magicpatterns.com';
    document.head.appendChild(cdnPreconnect);
    // DNS prefetch for checkout domain
    const checkoutPrefetch = document.createElement('link');
    checkoutPrefetch.rel = 'dns-prefetch';
    checkoutPrefetch.href = 'https://checkout.construyeprogreso.com';
    document.head.appendChild(checkoutPrefetch);
    // Preload critical hero images
    const heroMobilePreload = document.createElement('link');
    heroMobilePreload.rel = 'preload';
    heroMobilePreload.as = 'image';
    heroMobilePreload.href = 'https://cdn.magicpatterns.com/uploads/6BjEh6WkHCoeW2HEc4Y2ob/FondoCelular.png';
    heroMobilePreload.media = '(max-width: 768px)';
    document.head.appendChild(heroMobilePreload);
    const heroDesktopPreload = document.createElement('link');
    heroDesktopPreload.rel = 'preload';
    heroDesktopPreload.as = 'image';
    heroDesktopPreload.href = 'https://cdn.magicpatterns.com/uploads/r9di7UNFf23cY1m3hKZJGs/FondoPc.jpg';
    heroDesktopPreload.media = '(min-width: 769px)';
    document.head.appendChild(heroDesktopPreload);
    // Preload Google Fonts non-blocking
    const fontLink = document.createElement('link');
    fontLink.rel = 'stylesheet';
    fontLink.href = 'https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800;900&display=swap';
    fontLink.media = 'print';
    fontLink.onload = () => {
      fontLink.media = 'all';
    };
    document.head.appendChild(fontLink);
    // Meta Pixel - load immediately for accurate tracking
    const pixelScript = document.createElement('script');
    pixelScript.async = true;
    pixelScript.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '947072064512852');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(pixelScript);
    const noscript = document.createElement('noscript');
    noscript.innerHTML = `<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=947072064512852&ev=PageView&noscript=1" />`;
    document.body.appendChild(noscript);
    return () => {
      document.head.removeChild(cdnPreconnect);
      document.head.removeChild(checkoutPrefetch);
      document.head.removeChild(heroMobilePreload);
      document.head.removeChild(heroDesktopPreload);
      document.head.removeChild(fontLink);
      document.head.removeChild(pixelScript);
      document.body.removeChild(noscript);
    };
  }, []);
  return <div className="min-h-screen font-sans selection:bg-yellow-300 selection:text-gray-900" data-id="element-0">
      <UrgencyBar data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <HonestQuestion data-id="element-4" />
        <ProblemSection data-id="element-5" />
        <TomosSection data-id="element-6" />
        <BonusSection data-id="element-7" />
        <ForWhoSection data-id="element-8" />
        <PricingSection data-id="element-9" />
        <TestimonialsSection data-id="element-10" />
        <FAQSection data-id="element-11" />
      </main>
      <Footer data-id="element-12" />
      <SocialProofPopup data-id="element-13" />
    </div>;
}